import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

const IMG = "/images/giveaway.jpg";

export const Slide4 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={3} total={total} onActive={onActive} label="Value Engine">
      <div
        className="absolute inset-0 opacity-[0.65]"
        style={{
          backgroundImage: `url(${IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black via-black/90 to-black/70" />

      <div className="relative z-10 w-full max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-6">
            <div className="overline mb-6">{t.overline}</div>
            <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter">
              {t.heading}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="font-mono text-sm tracking-wider text-neutral-400">
              {t.sub}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.pillars.map((p, i) => (
            <div
              key={i}
              className="glass lift rounded-2xl p-7 flex flex-col justify-between min-h-[220px] relative overflow-hidden"
              data-testid={`s4-pillar-${i}`}
            >
              <div className="font-mono text-[10px] tracking-widest text-[var(--ph-accent)]">
                0{i + 1}
              </div>
              <div>
                <div className="font-display text-2xl md:text-3xl mb-3 leading-tight">
                  {p.t}
                </div>
                <p className="text-sm text-neutral-400 leading-relaxed">{p.d}</p>
              </div>
              <div className="absolute -bottom-12 -right-12 w-32 h-32 rounded-full bg-[var(--ph-accent-glow)] blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </SlideShell>
  );
};


